var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright 2020-2021 OnFinality Limited authors & contributors
// SPDX-License-Identifier: Apache-2.0
import * as React from 'react';
import Jazzicon, { jsNumberForAddress } from 'react-jazzicon';
import Typography from '../Typography';
import styles from './Address.module.css';
export function truncateAddress(address) {
    if (!address) {
        return address;
    }
    return "".concat(address.substring(0, 6), "...").concat(address.substring(address.length - 4));
}
var Address = function (_a) {
    var address = _a.address, _b = _a.truncated, truncated = _b === void 0 ? true : _b, _c = _a.size, size = _c === void 0 ? 'small' : _c;
    var iconSize = React.useMemo(function () {
        switch (size) {
            case 'small':
                return 18;
            case 'large':
            default:
                return 32;
        }
    }, [size]);
    return (_jsxs("div", __assign({ className: styles.container }, { children: [_jsx(Jazzicon, { diameter: iconSize, seed: jsNumberForAddress(address) }, void 0), _jsx(Typography, __assign({ variant: size === 'small' ? 'medium' : 'body', className: styles[size] }, { children: truncated ? truncateAddress(address) : address }), void 0)] }), void 0));
};
export default Address;
